import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

const AAutoFill = styled.a`
  background: ${props => props.bg};
  border: 1px solid ${props => props.bg};
`;

const Loader = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid ${props => props.bg};
  border-radius: 50%;
  height: 20px;
  width: 20px;
  margin-right: 5px;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const AutoFill = props => {
  const { trigger, loading, baseColour, text } = props;
  return (
    <AAutoFill bg={baseColour} className="auto_fill" onClick={trigger}>
      {loading && <Loader bg={baseColour} />}
      {text}
    </AAutoFill>
  );
};
const mapStateToProps = state => {
  return {
    baseColour: state.app.domain.BaseColour
  };
};
export default connect(
  mapStateToProps,
  null
)(AutoFill);
